import { DiscussionType } from "@cnx/common";
import { Box, BoxProps, ElementProps, Menu, Text } from "@mantine/core";
import {
  IconChevronLeft,
  IconDotsVertical,
  IconPhone,
  IconX,
} from "@tabler/icons-react";
import UserAvatar from "components/UserAvatar";
import { motion } from "motion/react";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import DiscussionIcon from "./DiscussionIcon";

interface ChatHeaderProps {
  discussionType: DiscussionType;
  children: ReactNode;
  discussionId?: string;
  phone?: string;
  avatarId?: string | null;
  participantName?: string;
  context?: string | null;
  stopActivityKind?: string | null;
  onGoBack?: () => void;
  onClose?: () => void;
  onViewParticipants?: () => void;
  typingLabel?: string | null;
  className?: string;
}

const MBox = motion.create(Box<BoxProps & ElementProps<"div", keyof BoxProps>>);

const ChatHeader: React.FC<ChatHeaderProps> = ({
  discussionType,
  onGoBack,
  onClose,
  onViewParticipants,
  phone,
  avatarId,
  participantName,
  context,
  stopActivityKind,
  children,
  typingLabel,
  className,
}) => {
  const { t } = useTranslation("discussions");

  /*
  Disabled until leaving discussion is supported
   const { discussionId: discussionIdParam } = useParams<{
    discussionId: string;
  }>();

  const discussionId = discussionIdProp ?? discussionIdParam;

  if (!discussionId) return null;
  
  const navigate = useNavigate();
  const [confirmOpened, { open: openConfirm, close: closeConfirm }] =
    useDisclosure(false);

  const { mutate: removeParticipant, isPending: isRemovingParticipant } =
    useRemoveParticipant({
      discussionId: discussionId ?? "",
      userId: currentUserId ?? "",
      onSuccess: () => {
        closeConfirm();
        navigate("/chat");
      },
    });

  const { participants } = useDiscussionParticipants({
    discussionId: discussionId ?? "",
  });

  const isAllowedToLeave = participants.some(
    p => p.id === currentUserId && !p.role
  );

  const handleDeleteDiscussion = () => {
    openConfirm();
  };
  */

  return (
    <MBox
      className={`bg-white w-full flex items-start justify-between sticky top-0 z-10${
        className ? ` ${className}` : ""
      }`}
      mih={66}
    >
      <Box className="flex items-center gap-2" mih={66}>
        {onGoBack ? (
          <button className="m-2 cursor-pointer" onClick={onGoBack}>
            <IconChevronLeft
              height={24}
              width={24}
              color="var(--color-gray-dark)"
            />
          </button>
        ) : (
          <div className="m-1 shrink-0" />
        )}

        {discussionType === DiscussionType.CONTEXT ? (
          <DiscussionIcon
            discussionType={discussionType}
            context={context}
            stopActivityKind={stopActivityKind}
            size={40}
          />
        ) : (
          <UserAvatar userName={participantName} avatarId={avatarId ?? ""} />
        )}
      </Box>
      <Box
        className="flex flex-col items-start px-4 grow"
        mih={66}
        style={{ paddingTop: 16 }}
      >
        {children}
        {typingLabel && (
          <Text fz={"sm"} c={"var(--color-blue)"}>
            {typingLabel} {t("typing").toLowerCase()}
          </Text>
        )}
      </Box>
      <Box className="flex items-center gap-2 mr-2" mih={66}>
        {phone && (
          <Link className="p-2" to={`tel:${phone}`}>
            <IconPhone className="text-green" />
          </Link>
        )}
        {onViewParticipants && (
          <Menu shadow="md" width={200} withArrow arrowOffset={0} offset={15}>
            <Menu.Target>
              <button className="p-2 cursor-pointer" aria-label="More options">
                <IconDotsVertical height={24} width={24} />
              </button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={onViewParticipants}>
                {discussionType === DiscussionType.PRIVATE
                  ? t("viewContact")
                  : t("viewGroupMembers")}
              </Menu.Item>
              {/*
                <Menu.Divider />
                <Menu.Item color="red" onClick={handleDeleteDiscussion}>
                  {discussionType === DiscussionType.PRIVATE
                    ? t("deleteDiscussion")
                    : t("leaveGroup")}
                </Menu.Item> */}
            </Menu.Dropdown>
          </Menu>
        )}
        {onClose && (
          <button
            onClick={onClose}
            className="p-0 flex items-center text-gray-dark hover:text-black cursor-pointer"
          >
            <IconX size={32} />
          </button>
        )}
      </Box>

      {/* confirmOpened && (
        <ConfirmModal
          opened={confirmOpened}
          close={closeConfirm}
          confirmMessage={
            discussionType === DiscussionType.PRIVATE
              ? String(t("deleteDiscussionConfirmation"))
              : String(t("leaveGroupConfirmation"))
          }
          confirmBtnLabel={
            discussionType === DiscussionType.PRIVATE ? t("delete") : t("leave")
          }
          confirmBtnColor="red"
          cancelBtnLabel={t("cancel")}
          isPending={isRemovingParticipant}
          handleConfirm={() => {
            removeParticipant();
          }}
        />
      ) */}
    </MBox>
  );
};

export default ChatHeader;
